import { render } from "./mainCard.vue?vue&type=template&id=4f3ff38a&scoped=true&lang=pug"
const script = {}

import "./mainCard.vue?vue&type=style&index=0&id=4f3ff38a&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3ff38a"]])

export default __exports__